<ng-container *transloco="let t">
  <title>{{ t("header.title") }}</title>
</ng-container>
<app-header />
<router-outlet />

<ng-container *transloco="let t">
  <app-dialog
    [isOpen]="consentDialogOpen()"
    (close)="onConsentDialogClose()"
    size="l"
  >
    <app-consent-dialog-content
      (agreed)="onConsentAgreed()"
      (cancelled)="onConsentDialogClose()"
    />
  </app-dialog>
</ng-container>
